// Route guard — every protected /carer/* page sits inside this <Outlet /> so
// missing/expired sessions bounce to /carer/login.
//
// Carer-parity S2 / D1c: bearer read migrated from direct getCarerToken() to
// useBearer().getBearer(). The carer subtree's <BearerProvider> (mounted in
// App.tsx) is configured for localStorage:carer_token, so the resolved
// bearer is the carer's access token.

import type { JSX } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useBearer } from "../../hooks/useBearer.js";

export function CarerGuard(): JSX.Element {
  const { getBearer } = useBearer();
  const token = getBearer();
  if (!token) return <Navigate to="/carer/login" replace />;
  return <Outlet />;
}
